import React from 'react';
import classNames from 'classnames';
import styles from './index.less';
import { ProjectOutlined } from '@ant-design/icons';
import { Space, Tag } from 'antd';
import { CaratPlanningModel } from '@/typings/models/CaratModel';
import { useCaratFormat } from '@/components/KitchenPlanning/Carat/format';
import { F } from '@/utils/intl';

export interface CaratPlanningItemProps {
  planning: CaratPlanningModel;
  onSelect: () => void;
}

export default function CaratPlanningItem({
  planning,
  onSelect,
}: CaratPlanningItemProps) {
  const format = useCaratFormat();

  const meta = [
    planning.agent_name,
    planning.deal_value ? format.money(Number(planning.deal_value)) : null,
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <div
      onClick={onSelect}
      className={classNames(
        styles.projectDetailItemContainer,
        styles.caratPlanningItemContainer,
        styles.projectDetailItemContainerClickable,
      )}
    >
      <div className={styles.projectDetailItemContent}>
        <div className={styles.projectDetailItemHeader}>
          <Space size={8}>
            <ProjectOutlined />
            {planning.commission_id}
            {planning.variation && (
              <Tag bordered={false}>
                <F
                  id="pages.integrations.carat.variation"
                  defaultMessage="Variation"
                />{' '}
                {planning.variation}
              </Tag>
            )}
          </Space>
        </div>
        {meta && <div className={styles.projectDetailItemBody}>{meta}</div>}
      </div>
    </div>
  );
}
